import React, { createContext, useContext } from 'react';
import { PriceDisplayEnum } from 'src/components/price-list/types';
import { IPriceRowContext } from './price-row/types';

const initialValue: IPriceRowContext = {
  productId: -1,
  priceDisplay: PriceDisplayEnum.PRICE,
  offer: {
    featured: false,
    authorizedDealer: false,
    isInternationalPrice: false,
  },
  showExpandButton: true,
};
const PriceRowContext = createContext<IPriceRowContext>(initialValue);

export const usePriceRowContext = () => useContext(PriceRowContext);

export const PriceRowContextContainer: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceRowContext>
>> = props => {
  return (
    <PriceRowContext.Provider value={props}>
      {props.children}
    </PriceRowContext.Provider>
  );
};
